// Only an acknowledged workflow operation clears the pending create. If its
// response is lost, a reload retries the same body and server idempotency key.
export const rmActionStorageKey = (owner, customer) => `rm-action:${JSON.stringify([owner, customer])}`;
export const readRmAction = ({storage, owner, customer}) => JSON.parse(storage.getItem(rmActionStorageKey(owner, customer)) || 'null');
export function prepareRmAction({storage, owner, customer, payload, makeId = () => crypto.randomUUID()}) {
    if (!owner) throw new Error('Sign in again before saving an action.');
    const key = rmActionStorageKey(owner, customer);
    const existing = JSON.parse(storage.getItem(key) || 'null');
    if (existing) {
        if (existing.action_type !== payload.action_type) throw new Error('An earlier action has an unconfirmed response. Retry that action first.');
        return existing;
    }
    const attempt = {...payload, idempotency_key: makeId()};
    storage.setItem(key, JSON.stringify(attempt));
    return attempt;
}
export const completeRmAction = ({storage, owner, customer}) => storage.removeItem(rmActionStorageKey(owner, customer));
